export const SEARCH_REGION_ASYNC = 'SEARCH_REGION_ASYNC';
export const SEARCH_REGION_SUCCESS = 'SEARCH_REGION_SUCCESS';

export const CREATE_REGION_ASYNC = 'CREATE_REGION_ASYNC';
export const UPDATE_REGION_ASYNC = 'UPDATE_REGION_ASYNC';

export const GET_REGION_BY_ID_ASYNC = 'GET_REGION_BY_ID_ASYNC';
export const GET_REGION_BY_ID_SUCCESS = 'GET_REGION_BY_ID_SUCCESS';

export const CREATE_MARKET_ASYNC = 'CREATE_MARKET_ASYNC';

export const UPDATE_MARKET_ASYNC = 'UPDATE_MARKET_ASYNC';

export const GET_MARKET_BY_ID_ASYNC = 'GET_MARKET_BY_ID_ASYNC';
export const GET_MARKET_BY_ID_SUCCESS = 'GET_MARKET_BY_ID_SUCCESS';

export const RESET_REGION_MARKET = 'RESET_REGION_MARKET';

export const ADD_EDIT_REGION_MARKET_ERROR = 'ADD_EDIT_REGION_MARKET_ERROR';

export const OPEN_FORM_CREATE_REGION = 'OPEN_FORM_CREATE_REGION';

export const OPEN_FORM_CREATE_MARKET = 'OPEN_FORM_CREATE_MARKET';

export const GET_LIST_REGION_ASYNC = 'GET_LIST_REGION_ASYNC';
export const GET_LIST_REGION_SUCCESS = 'GET_LIST_REGION_SUCCESS';

export const GET_LIST_MARKET_ASYNC = 'GET_LIST_MARKET_ASYNC';
export const GET_LIST_MARKET_SUCCESS = 'GET_LIST_MARKET_SUCCESS';

export const GET_LIST_MARKET_BY_REGION_ASYNC = 'GET_LIST_MARKET_BY_REGION_ASYNC';

export const GET_REPORT_REGION_LIST_ASYNC = 'GET_REPORT_REGION_LIST_ASYNC';

export const GET_REPORT_MARKET_LIST_ASYNC = 'GET_REPORT_MARKET_LIST_ASYNC';

export const SETUP_REGION_PO_AWS_ASYNC = 'SETUP_REGION_PO_AWS_ASYNC';
export const SETUP_REGION_PO_AWS_SUCCESS = 'SETUP_REGION_PO_AWS_SUCCESS';
export const UPLOAD_REGION_PO_TO_S3_ASYNC = 'UPLOAD_REGION_PO_TO_S3_ASYNC';
export const UPLOAD_REGION_PO_TO_SERVER_ASYNC = 'UPLOAD_REGION_PO_TO_SERVER_ASYNC';
export const UPLOAD_REGION_PO_TO_SERVER_SUCCESS = 'UPLOAD_REGION_PO_TO_SERVER_SUCCESS';
export const REMOVE_REGION_PO_ASYNC = 'REMOVE_REGION_PO_ASYNC';
export const REMOVE_REGION_PO_SUCCESS = 'REMOVE_REGION_PO_SUCCESS';
export const DOWNLOAD_REGION_PO_ASYNC = 'DOWNLOAD_REGION_PO_ASYNC';
export const GET_REGION_PO_ASYNC = 'GET_REGION_PO_ASYNC';
export const GET_REGION_PO_SUCCESS = 'GET_REGION_PO_SUCCESS';
export const RESET_REGION_PO = 'RESET_REGION_PO';




// WEBPACK FOOTER //
// ./src/Region-Market/constants.js